<footer class="footer" style="position: relative;">
  <div class="container-fluid">
    <nav class="float-start">
      <ul>
        <li>
<!--           <a href="#"> Aviso de privacidad </a>
 -->        </li>
      </ul>
    </nav>
    <div class="copyright float-end">
      &copy;
      {{ date | date: "yyyy" }}, Mutuus. v {{version}}
 
    </div>
  </div>
</footer>
